import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {equals} from 'ramda'
import Analytics from '..'
import {extractChildrenText} from '../utils'

const withAnalyticsOnClick = WrappedComponent =>
  class extends Component {
    static propTypes = {
      onClick: PropTypes.func,
      href: PropTypes.string,
      children: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.element
      ])
    }

    static defaultProps = {onClick: () => {}}

    static displayName = `${WrappedComponent.displayName}WithAnalyticsOnClick`

    constructor(props) {
      super(props)

      this.analytics = new Analytics(props.analytics)
    }

    componentDidUpdate(prevProps) {
      if (
        prevProps.analytics &&
        !equals(prevProps.analytics.contexts, this.props.analytics.contexts)
      ) {
        this.analytics = new Analytics(this.props.analytics)
      }
    }

    onClick = (event, eventData = {}, ...args) => {
      const {onClick, children, href, analyticsText} = this.props,
        {disabled = false} = eventData

      this.analytics.event({
        href,
        activated: !disabled,
        text: analyticsText ? analyticsText : extractChildrenText(children)
      })

      onClick(event, eventData, ...args)
    }

    render() {
      const {onClick, ...props} = this.props

      return <WrappedComponent onClick={this.onClick} {...props}/>
    }
  }

export default withAnalyticsOnClick
